var map = {
	"./zuanshi-bg-0.png": 5782,
	"./zuanshi-bg-1.png": 3871,
	"./zuanshi-bg-2.png": 308,
	"./zuanshi-bg-3.png": 6461,
	"./zuanshi-bg-4.png": 4898,
	"./zuanshi-bg-5.png": 251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1421;